import { render, staticRenderFns } from "./FloatingCard.vue?vue&type=template&id=8749ae36"
import script from "./FloatingCard.vue?vue&type=script&lang=js"
export * from "./FloatingCard.vue?vue&type=script&lang=js"
import style0 from "./FloatingCard.vue?vue&type=style&index=0&id=8749ae36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports